

<script>
import ProductTemplateLimitedEducation3 from '@/components/templates/products/limited-education-2021-group3'

export default {
  name: 'ProductTemplateLimitedEducation5',

  mixins: [ProductTemplateLimitedEducation3],
  props: {
    title: {type: String, default: 'Napkins'}
  },

  data () {
    return {
      itemCounts: [0, 0, 0],
      itemPrices: [990, 1590, 1590],
      itemInfos: [
        {name: 'Napkin', value: 'Napkin Napkin'},
        {name: 'เซ็ทเซรามิค ลายเด็กผู้ชาย +Napkin', value: 'Napkin เซ็ทเซรามิค ลายเด็กผู้ชาย + Napkin'},
        {name: 'เซ็ทเซรามิค ลายเด็กผู้หญิง + Napkin', value: 'Napkin เซ็ทเซรามิค ลายเด็กผู้หญิง + Napkin'}
      ],
      itemImages: [
        [
          {thumb: '/static/img/limited-edu/lmt-product-ad-01.jpg', large: '/static/img/limited-edu/shirt1_ad.png'},
          {thumb: '/static/img/limited-edu/lmt-product-ad-02.jpg', large: '/static/img/limited-edu/shirt2_ad.png'},
          {thumb: '/static/img/limited-edu/lmt-product-ad-03.jpg', large: '/static/img/limited-edu/shirt3_ad.png'}
        ],
        [
          {thumb: '/static/img/limited-edu/lmt-product-ad-01.jpg', large: '/static/img/limited-edu/shirt1_ad.png'},
          {thumb: '/static/img/limited-edu/lmt-product-ad-02.jpg', large: '/static/img/limited-edu/shirt2_ad.png'},
          {thumb: '/static/img/limited-edu/lmt-product-ad-03.jpg', large: '/static/img/limited-edu/shirt3_ad.png'}
        ],
        [
          {thumb: '/static/img/limited-edu/lmt-product-ad-01.jpg', large: '/static/img/limited-edu/shirt1_ad.png'},
          {thumb: '/static/img/limited-edu/lmt-product-ad-02.jpg', large: '/static/img/limited-edu/shirt2_ad.png'},
          {thumb: '/static/img/limited-edu/lmt-product-ad-03.jpg', large: '/static/img/limited-edu/shirt3_ad.png'}
        ]
      ],
      activeImages: [0, 0, 0]
    }
  }
}
</script>



// WEBPACK FOOTER //
// limited-education-2021-group5.vue?1d9dcc9a